import registerModelTwo from "./registerModelTwo";
import registerFormation from "./registerFormation";
export default [registerModelTwo,registerFormation ];
